import React from 'react';
import { Navigate } from 'react-router-dom';

import MenuBar from '@common/components/MenuBar/MenuBar';
import { useAuthStore } from '@store/authStore';
import TedTheme from '@common/providers/ThemeProvider/TedTheme';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();

  return isAuthenticated ? (
    <>
      <TedTheme>
        <MenuBar />
      </TedTheme>

      {children}
    </>
  ) : (
    <Navigate to='/' />
  );
};

export default PrivateRoute;
